import React from 'react';
import css from './css.module.less';
import Input from '@/src/components/Antd/Input/Input';
import NumberInput, {
  OriNumberInput,
} from '@/src/components/Antd/NumberInput/NumberInput';
import Select from 'src/components/Antd/Select/OriginalSelect';
//import { SearchSelect } from 'src/components/Antd';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';

const TableForm = (props) => {
  const [_focus, _setFocus] = React.useState(false);
  const { _mustEditting, children, blur, label, containerClassName, disabled } =
    props;

  const onFocus = (e) => {
    e.stopPropagation();
    _setFocus(true);
  };
  const onBlur = () => {
    if (!_mustEditting) _setFocus(false);
  };
  useAfterDidMountEffect(() => {
    if (_mustEditting) {
      _setFocus(true);
    }
  }, [_mustEditting]);
  useAfterDidMountEffect(() => {
    onBlur();
  }, [blur]);

  const _editting = !disabled && (_focus || _mustEditting);
  return (
    <div className={`${css.container} ${containerClassName}`} onClick={onFocus}>
      {_editting ? (
        <div className={css.edittingContainer}>{children}</div>
      ) : (
        <NoWrapContainer>
          <GlobalTooltip title={label}>{label}</GlobalTooltip>
        </NoWrapContainer>
      )}
    </div>
  );
};

// const useOnBlur = ({ onBlurCallback }) => {
//   const [blur, setBlur] = React.useState(null);
//   const handleOnBlue = () => {
//     if (onBlurCallback) {
//       onBlurCallback(() => {
//         setBlur(JSON.stringify(new Date()));
//       });
//     } else {
//       setBlur(JSON.stringify(new Date()));
//     }
//   };
// };

//也可以写进useOnBlur 不过无所谓了
const Wrapper = (Item: any) => {
  const WrappedComponent = (props: any) => {
    const {
      error,
      value,
      label,
      onChange,
      placeholder,
      onBlurCallback, //Optional
      itemProps, //往input select等组件里面传的参数
      containerProps: _containerProps, //{containerClassName}
      children,
      disabled,
    } = props;
    const [onBlur, setOnBlur] = React.useState(null);
    const handleOnBlue = () => {
      if (onBlurCallback) {
        onBlurCallback(() => {
          setOnBlur(JSON.stringify(new Date()));
        });
      } else {
        setOnBlur(JSON.stringify(new Date()));
      }
    };

    const containerProps = {
      blur: onBlur,
      _mustEditting: error,
      value,
      label,
      disabled,
      ...(_containerProps || {}),
    };
    const childProps = {
      error,
      value,
      onChange,
      children,
      placeholder,
      disabled,
      ...(itemProps || {}),
      _onBlur: handleOnBlue,
    };

    const returnComp = (
      <TableForm {...containerProps}>
        <Item {...childProps} />
      </TableForm>
    );
    return returnComp;
  };
  return WrappedComponent;
};

const _TableInput = (props) => {
  const { _onBlur, error, value, placeholder, ...rest } = props;
  return (
    <Input
      autoFocus
      onBlur={_onBlur}
      placeholder={placeholder}
      error={error}
      value={value}
      {...rest}
    />
  );
};
const _TableSelect = (props) => {
  const { _onBlur, error, value, placeholder, ...rest } = props;
  return (
    <Select
      autoFocus
      onBlur={_onBlur}
      placeholder={placeholder}
      error={error}
      value={value}
      {...rest}
    />
  );
};
const _TableNumberInput = (props) => {
  const { _onBlur, error, value, placeholder, ...rest } = props;
  return (
    <NumberInput
      autoFocus
      placeholder={placeholder}
      onBlur={_onBlur}
      error={error}
      value={value}
      {...rest}
    />
  );
};
const _TableNumberInputFormItemSupport = (props) => {
  const {
    _onBlur, // error,
    value,
    placeholder,
    ...rest
  } = props;
  //console.log('itemProps', rest);
  return (
    <OriNumberInput
      autoFocus
      placeholder={placeholder}
      onBlur={_onBlur}
      // error={error}
      value={value}
      {...rest}
    />
  );
};

const _TableNumberInputWithSlash = (props) => {
  const {
    _onBlur, // error,
    value,
    placeholder,
    backPart,
    onBlur,

    ...rest
  } = props;
  //console.log('rest', rest);
  //console.log('backPart', backPart);
  return (
    <div className={css.slashContainer}>
      <OriNumberInput
        autoFocus
        placeholder={placeholder}
        onBlur={(e) => {
          _onBlur();
          if (onBlur) {
            onBlur(e.target.value);
          }
        }}
        //className={css.inputPart}
        // error={error}
        value={value}
        {...rest}
      />
      {backPart}
    </div>
  );
};

const TableNumberInputWithSlash = Wrapper(_TableNumberInputWithSlash);
const TableInput = Wrapper(_TableInput);
//const TableSearchSelect = Wrapper(_TableSerachSelect);
const TableSelect = Wrapper(_TableSelect);
const TableNumberInput = Wrapper(_TableNumberInput);
const TableNumberInputFormItemSupport = Wrapper(
  _TableNumberInputFormItemSupport,
);

export {
  //TableSearchSelect,
  TableInput,
  TableSelect,
  TableNumberInput,
  Wrapper,
  TableNumberInputFormItemSupport,
  TableNumberInputWithSlash,
  // generateOptions,
};
